import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { AUTH_CONFIG } from "./config";
import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "@asgardeo/auth-react";

ReactDOM.render(
    <AuthProvider config={AUTH_CONFIG}>
        <App />
    </AuthProvider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
